import gql from 'graphql-tag';

export const PLAN_FIELDS = gql`
	fragment PlanFields on Plan {
		_id
		createdDate
		createdById
		lastModifiedDate
		lastModifiedById
		projectId
		orgId
		type
	}
`;
